
import React from 'react';

interface Section {
  id: string;
  label: string;
}

interface CampaignFormTabsProps {
  sections: Section[];
  activeSection: string;
  onSectionChange: (sectionId: string) => void;
}

const CampaignFormTabs: React.FC<CampaignFormTabsProps> = ({
  sections,
  activeSection,
  onSectionChange
}) => {
  return (
    <div className="mb-8">
      <div className="flex overflow-x-auto border-b border-neutral-200">
        {sections.map((section, index) => (
          <button
            key={section.id}
            onClick={() => onSectionChange(section.id)}
            className={`px-6 py-3 text-sm font-semibold whitespace-nowrap transition-colors ${
              activeSection === section.id
                ? 'text-red-700 border-b-2 border-red-600 bg-red-50'
                : 'text-neutral-600 hover:text-red-600 hover:bg-neutral-50'
            }`}
          >
            {index + 1}. {section.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CampaignFormTabs;
